import { useMutation } from "react-query";
import { useSetRecoilState } from "recoil";
import { error_message, success_message } from '../../global_state'
import { add_new_certificate } from "../../services/jobs";


const useAddCertificate = () => {
  const set_error = useSetRecoilState(error_message)
  const set_success = useSetRecoilState(success_message)

  return  useMutation((certificate_name)=>add_new_certificate(certificate_name), {
      onSuccess: data => {
        set_success('Successfully added certificate!')
        setTimeout(() => {
          set_success('')
        }, 4000);
      },
      onError: () => {
        set_error(`Certificate already exists!`)
        setTimeout(() => {
          set_error('')
        }, 4000);
      }
  })
}

export default useAddCertificate;
